<div *transloco="let t; read: 'bp'" class="flex flex-row gap-2" [formGroup]="filterValuesForm">
    <!-- Search field -->
    <mat-form-field class="w-full search-field" appearance="outline">
        <input #input matInput formControlName="searchString" placeholder="{{ t('search') }}" />

        @if (input.value) {
            <button mat-icon-button matSuffix (click)="clearSearchString()">
                <mat-icon class="icon-size-4.5">close</mat-icon>
            </button>
        }
    </mat-form-field>

    <!-- Filter button -->
    <button
        mat-icon-button
        class="my-auto"
        [matTooltip]="t('filterOptions')"
        (click)="openFilterDialog()">
        <mat-icon>filter_list</mat-icon>
    </button>
</div>
